import {useContext} from "react";
import AppContext from "../AppContext";
import {Navigate} from "react-router-dom";
import SimUnified from "./SimUnified";

export default function Simulation() {
    const app = useContext(AppContext)
    switch(app.user?.current_course) {
        // case 1:
        //     return <SimBTH />
        // case 2:
        // case 3:
        //     return <SimATH />
        case 1:
        case 2:
        case 3:
            return <SimUnified />
        default:
            return <Navigate to="/" />
    }
}